import { Table } from 'antd';
import { document } from 'src/api';
import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /** 保存搜索 列表首页的搜索条件 */
    public recordSearch: any = undefined;
    /** 文档Id */
    public documentUUID: string = '';
    /** 单据类型 */
    public documentType: string =  '';
    /** 是否已归档 */
    public isArchived: boolean = false;
    /** 发送方/接收方 */
    public isSenderParty: boolean = false;
    /** 文档允许操作状态 */
    public allowedTargetStatus: Array<string> = [];
    /** 单据状态 拒绝或接受 */
    public documentStatus: string = '';
    /** 拒绝 弹框 */
    public refuseM: boolean = false;
    public refuseType: string = '';
    /** 拒绝理由输入 */
    public refuseInputNum: number = 0;

    /** 转换单据 弹框 */
    public selectBillTypeM: boolean = false;
    /** 转换单据 选择 */
    public createBillType: string = '';
    /** 允许选择转换的单据类型列表 */
    public allowedDocType: Array<string> = [];
    
    /** 分页信息 */
    public pageNum: number = 1;
    public pageSize: number = 10;
    public total: number = 0;
    // 国家
    public countryList: {
        code: string;
        name: string;
    }[] = [];
    /** 自定义单据规则 */
    public rules: any = {
        Lines: {
            Extra: {
            },
        },
        Extra: {
        }
    };
    /** 详情信息 订单 */
    public documentInfo: {
        DocumentType: string;
        ID: string;
        IssueDate: number;
        RejectReason: string;
        DocumentCurrencyCode: string;
        BuyerCustomerParty: {
            ID: string;
            Name: string;
        };
        BuyerContact: {
            ID: string;
            Name: string;
        };
        SellerSupplierParty: {
            ID: string;
            Name: string;
        };
        SellerContact: {
            ID: string;
            Name: string;
        };
        RequestedDeliveryPeriod: {
            StartDate: string;
            EndDate: string;
        };
        Lines: {
            Number: number;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            Quantity: number;
            LineExtensionAmount: number;
            Description: string;
            UnitCode: string;
            Price: string;
        }[];
        Total: number;
        PaymentMeans: string;
        Note: string;
        DeliveryAddress: {
            Country: string;
            CountrySubentity: string;
            CityName: string;
            AddressLine: string;
        };
        DeliveryContact: {
            Name: string;
            Phone: string;
        };
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
            DocumentType: '',
            ID: '',
            IssueDate: undefined,
            RejectReason: undefined,
            DocumentCurrencyCode: '',
            BuyerCustomerParty: {
                ID: '',
                Name: '',
            },
            BuyerContact: {
                ID: '',
                Name: '',
            },
            SellerSupplierParty: {
                ID: '',
                Name: '',
            },
            SellerContact: {
                ID: '',
                Name: '',
            },
            RequestedDeliveryPeriod: {
                StartDate: '',
                EndDate: '',
            },
            Lines: [],
            Total: 0,
            PaymentMeans: '',
            Note: '',
            DeliveryAddress: {
                Country: undefined,
                CountrySubentity: undefined,
                CityName: undefined,
                AddressLine: '',
            },
            DeliveryContact: {
                Name: '',
                Phone: '',
            },
            Attachments: [],
        };
    /** 计划单 */
    public forecastForm: {
        DocumentType: string;
        ForecastPurposeCode: string;
        RejectReason: string;
        ID: string;
        IssueDate: number;
        DocumentCurrencyCode: string;
        SenderParty: {
            ID: string;
            Name: string;
        };
        SenderContact: {
            ID: string;
            Name: string;
        };
        ReceiverParty: {
            ID: string;
            Name: string;
        };
        ReceiverContact: {
            ID: string;
            Name: string;
        };
        ForecastPeriod: {
            StartDate: string;
            EndDate: string;
        },
        Lines: {
            Number: number;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            Description: string;
            UnitCode: string;
            Quantity: number;
            ForecastStageQuantity: {
                Date: string;
                Quantity: number;
            }[];
        }[];
        Note: string;
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
        DocumentType: '',
        ForecastPurposeCode: undefined,
        RejectReason: '',
        ID: undefined,
        IssueDate: undefined,
        DocumentCurrencyCode: undefined,
        SenderParty: {
            ID: undefined,
            Name: undefined,
        },
        SenderContact: {
            ID: undefined,
            Name: undefined,
        },
        ReceiverParty: {
            ID: undefined,
            Name: undefined,
        },
        ReceiverContact: {
            ID: undefined,
            Name: undefined,
        },
        ForecastPeriod: {
            StartDate: undefined,
            EndDate: undefined,
        },
        Lines: [],
        Note: '',
        Attachments: [],
    };
    /**
     * 发货单
     */
    public despatchAdviceForm: {
        RejectReason: string;
        DocumentType: string;
        ID: string;
        IssueDate: number;
        DespatchSupplierParty: {
            ID: string;
            Name: string;
        };
        DespatchSupplierContact: {
            ID: string;
            Name: string;
        };
        DeliveryCustomerParty: {
            ID: string;
            Name: string;
        };
        DeliveryCustomerContact: {
            ID: string;
            Name: string;
        };
        Lines: {
            Number: string;
            DocumentReference: string;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            UnitCode: string;
            OrderedQuantity: number;
            DeliveredQuantity: number;
            Description: string;
            DocumentReference2: string;
            LineReference2: string;
        }[];
        DeliveryAddress: {
            Country: string;
            CountrySubentity: string;
            CityName: string;
            AddressLine: string;
        };
        DeliveryContact: {
            Name: string;
            Phone: string;
        },
        DeliveryDate: number;
        TransportModeCode: string;
        TransportMeansTrackingID: string;
        PerformingCarrierPartyContact: {
            ID: string;
            Name: string;
            Phone: string;
        };
        CarrierParty: {
            ID: string;
            Name: string;
        };
        Note: string;
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
        RejectReason: undefined,
        DocumentType: undefined,
        ID: undefined,
        IssueDate: undefined,
        DespatchSupplierParty: {
            ID: undefined,
            Name: undefined,
        },
        DespatchSupplierContact: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryCustomerParty: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryCustomerContact: {
            ID: undefined,
            Name: undefined,
        },
        Lines: [],
        DeliveryAddress: {
            Country: undefined,
            CountrySubentity: undefined,
            CityName: undefined,
            AddressLine: undefined,
        },
        DeliveryContact: {
            Name: undefined,
            Phone: undefined,
        },
        DeliveryDate: undefined,
        TransportModeCode: undefined,
        TransportMeansTrackingID: undefined,
        PerformingCarrierPartyContact: {
            ID: undefined,
            Name: undefined,
            Phone: undefined,
        },
        CarrierParty: {
            ID: undefined,
            Name: undefined,
        },
        Note: undefined,
        Attachments: [],
    };
    /**
     * 收货单
     */
    public receiptAdviceForm: {
        ReceiptAdviceTypeCode: string;
        RejectReason: string;
        DocumentType: string;
        PostingDate: string;
        ID: string;
        IssueDate: string;
        DespatchSupplierParty: {
            ID: string;
            Name: string;
        };
        DespatchSupplierContact: {
            ID: string;
            Name: string;
        };
        DeliveryCustomerParty: {
            ID: string;
            Name: string;
        };
        DeliveryCustomerContact: {
            ID: string;
            Name: string;
        };
        DeliveryDate: string;
        TransportModeCode: string;
        TransportMeansTrackingID: string;
        PerformingCarrierPartyContact: {
            ID: string;
            Name: string;
        };
        CarrierParty: {
            ID: string;
            Name: string;
        };
        DeliveryNote: string;
        Lines: {
            LineID: string;
            DocumentReference: string;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            UnitCode: string;
            DeliveredQuantity: number;
            ReceivedQuantity: number;
            Description: string;
        }[];
        ActualDespatchDate: string;
        DespatchAddressLine: string;
        Note: string;
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
        PostingDate: undefined,
        RejectReason:undefined,
        ReceiptAdviceTypeCode: null,
        DocumentType: undefined,
        ID: undefined,
        IssueDate: undefined,
        DespatchSupplierParty: {
            ID: undefined,
            Name: undefined,
        },
        DespatchSupplierContact: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryCustomerParty: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryCustomerContact: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryDate: undefined,
        TransportModeCode: undefined,
        TransportMeansTrackingID: undefined,
        PerformingCarrierPartyContact: {
            ID: undefined,
            Name: undefined,
        },
        CarrierParty: {
            ID: undefined,
            Name: undefined,
        },
        DeliveryNote: undefined,
        Lines: [],
        ActualDespatchDate: undefined,
        DespatchAddressLine: undefined,
        Note: undefined,
        Attachments: [],
    };
    /**
     * 入库单
     */
    public stockInNoticeForm: {
        RejectReason: string;
        PostingDate: string;
        DocumentType: string;
        ID: string;
        IssueDate: number;
        BuyerCustomerParty: {
            ID: string;
            Name: string;
        };
        BuyerContact: {
            ID: string;
            Name: string;
        };
        SellerSupplierParty: {
            ID: string;
            Name: string;
        };
        SellerContact: {
            ID: string;
            Name: string;
        };
        PickupPeriod: {
            StartDate: string;
            EndDate: string;
        };
        Lines: {
            LineID: string;
            DocumentReference: string;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            UnitCode: string;
            ReceivedQuantity: string;
            StockInQuantity: string;
            Description: string;
        }[];
        Note: string;
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
        RejectReason: undefined,
        PostingDate: undefined,
        DocumentType: undefined,
        ID: undefined,
        IssueDate: undefined,
        BuyerCustomerParty: {
            ID: undefined,
            Name: undefined,
        },
        BuyerContact: {
            ID: undefined,
            Name: undefined,
        },
        SellerSupplierParty: {
            ID: undefined,
            Name: undefined,
        },
        SellerContact: {
            ID: undefined,
            Name: undefined,
        },
        PickupPeriod: {
            StartDate: undefined,
            EndDate: undefined,
        },
        Lines: [],
        Note: undefined,
        Attachments: [],
    };
    /** 
     * 合同
     */
    public ContractForm: {
        DocumentType: string;
        RejectReason: string;
        ID: string;
        IssueDate: number;
        DocumentCurrencyCode: string;
        BuyerCustomerParty: {
            ID: string;
            Name: string;
        };
        BuyerContact: {
            ID: string;
            Name: string;
        };
        SellerSupplierParty: {
            ID: string;
            Name: string;
        };
        SellerContact: {
            ID: string;
            Name: string;
        };
        ValidityPeriod: {
            StartDate: number;
            EndDate: number;
        };
        Lines: {
            Number: number;
            BuyersItemIdentification: string;
            BuyersItemName: string;
            BuyersItemModelName: string;
            SellersItemIdentification: string;
            SellersItemName: string;
            SellersItemModelName: string;
            Quantity: number;
            LineExtensionAmount: string;
            DocumentReference: string;
            LineReference: string;
            Description: string;
            UnitCode: string;
            Price: string;
            BaseQuantity: number;
            TaxRate: number;
        }[];
        Total: number;
        Note: string;
        Attachments: {
            FileName: string;
            UUID: string;
        }[];
    } = {
            DocumentType: '',
            RejectReason: '',
            ID: '',
            IssueDate: undefined,
            DocumentCurrencyCode: '',
            BuyerCustomerParty: {
                ID: '',
                Name: '',
            },
            BuyerContact: {
                ID: '',
                Name: '',
            },
            SellerSupplierParty: {
                ID: '',
                Name: '',
            },
            SellerContact: {
                ID: '',
                Name: '',
            },
            ValidityPeriod: {
                StartDate: undefined,
                EndDate: undefined,
            },
            Lines: [],
            Total: 0,
            Note: '',
            Attachments: [],
        };
    public billType: string = '';
    public tableList: any[] = [];
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentDetail/Modules.State.ts